import { RATING_STYLES } from "../../constants/ratings";

export const RatingBadge = ({ rating, testId }) => {
  if (!rating) {
    return (
      <span
        data-testid={testId}
        className="inline-flex items-center rounded border border-dashed border-zinc-700 px-2 py-0.5 font-mono text-xs text-zinc-600"
      >
        --
      </span>
    );
  }
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded border px-2 py-0.5 font-mono text-xs font-semibold ${
        RATING_STYLES[rating] || RATING_STYLES.PASS
      }`}
    >
      {rating}
    </span>
  );
};
